import { render, staticRenderFns } from "./emoji-search-dialog.vue?vue&type=template&id=4f7d5a5a&scoped=true&"
import script from "./emoji-search-dialog.vue?vue&type=script&lang=js&"
export * from "./emoji-search-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7d5a5a",
  null
  
)

export default component.exports